module.exports = __webpack_public_path__ + "static/media/clock.9ba5ea8a.svg";